<template>
  <div class="system-announcement">
    <div class="system-announcement-left">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="system-announcement-right">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
    <!-- 发布 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'发布系统消息'"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose"
    >
      <div class="form-detail">
        <!-- <div class="select-tree">
					<el-tree ref="selectedTree" :props="props" @node-click="handleNodeClick" :load="loadNode" lazy> </el-tree>
				</div> -->
        <el-form
          :disabled="ruleFormDisabeld"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="ruleForm.title" maxlength="35"></el-input>
          </el-form-item>
          <el-form-item label="区域" prop="centerId">
            <template>
              <div class="input-district">
                <el-select
                  class="form-select-drop"
                  v-model="ruleForm.areaName"
                  placeholder="请选择"
                >
                  <el-option class="form-select-drop-options" value="">
                    <el-tree
                      :props="props"
                      @node-click="nodeClickArea"
                      :load="loadNode"
                      lazy
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <el-input
              type="textarea"
              :rows="4"
              maxlength="500"
              placeholder="请输入发布内容"
              v-model="ruleForm.content"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="!ruleFormDisabeld">
            <el-button type="primary" @click="onSubmit('ruleForm')">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import publicAPI from "../../../../api-path/public-api.js";
import { mediaApi } from "../../../../api-path/media-api.js";
import PublicFn from "../../../../assets/js/publicFn.js";
export default {
  name: "system-announcement",
  components: {
    Tree,
    TabelSearch,
  },
  data() {
    return {
      publicAPI,
      squareUrl: "",
      switchVal: false,
      areaId: "",
      areaName: "",
      ruleFormDisabeld: false,
      //表格start
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "time",
            valueType: "datetimerange",
          },
          {
            key: "search",
            valueType: "text",
            placeholder: "输入发布人/标题搜索",
          },
        ],
      },
      searchParams: {
        search: "",
        areaId: "",
        areaName: "",
        startTime: "",
        endTime: "",
        isDown: false,
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            (this.ruleForm = {
              title: "",
              centerId: this.areaId,
              content: "",
              areaName: this.areaName,
            }),
              (this.ruleFormDisabeld = false);
            this.dialogVisible = true;
          },
        },
      ],
      tableTemplateData: [],
      tableConfig: {
        checkbox: false,
        checkboxFn: (data) => {
          console.log(data);
        },
        rows: [
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "标题",
            prop: "title",
            type: "popover",
            width: "200px",
          },
          {
            label: "发布单位",
            prop: "centerName",
          },
          {
            label: "发布人",
            prop: "userName",
          },
          {
            label: "发布时间",
            prop: "createGmt",
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "查看",
              fn: (data) => {
                this.ruleForm = data;
                this.dialogVisible = true;
                this.ruleFormDisabeld = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("是否删除该公告?", "删除区域", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .get(`${mediaApi.delMsg}`, { params: { id: data.id } })
                      .then((res) => {
                        if (res.status === 200) {
                          this.$message({
                            type: "success",
                            message: "操作成功!",
                          });
                          this.setSearchParams();
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消删除",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      //表格end
      //表单配置start
      dialogVisible: false,
      ruleForm: {
        title: "",
        centerId: "",
        areaName: "",
        content: "",
      },
      rules: {
        title: [
          {
            required: true,
            trigger: "blur",
            message: "请填写标题",
          },
        ],
        centerId: [
          {
            required: true,
            trigger: "blur",
            message: "请选择区域",
          },
        ],
        content: [
          {
            required: true,
            trigger: "blur",
            message: "请填写发布内容",
          },
        ],
      },
      //区域选择树
      props: {
        label: "name",
        key: "id",
        children: "areaTreeListResList",
      },
    };
  },
  methods: {
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.isDown = e;
      this.setSearchParams();
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.areaId = node.id;
      this.areaName = node.id ? node.name : "";
      this.searchParams.areaName = node.name;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.setSearchParams();
    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
      this.searchParams.search = "";
      this.searchParams.time = [];
      this.searchParams.areaId = this.areaId;
      this.searchParams.areaName = this.areaName;
      this.searchParams.isDown = this.isDown;
      this.setSearchParams();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.setSearchParams();
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.time && params.time != "" && params.time.length != 0) {
        params.startTime = PublicFn.formatDate(params.time[0]).toString();
        params.endTime = PublicFn.formatDate(params.time[1]).toString();
      }
      delete params.time;
      this.$http.get(mediaApi.queryListByPageMsg, { params: params }).then((res) => {
        if (res.status === 200) {
          this.tableTemplateData = res.result.pageList;
          this.pagination.total = res.result.total;
        }
      });
    },
    handleClose() {
      this.$refs["ruleForm"].clearValidate();
      this.dialogVisible = false;
    },
    //发布
    addHandleClose() {
      this.dialogVisible = false;
    },
    //获取tree数据
    loadNode(node, resolve) {
      const $this = this;
      if (node.level === 0) {
        let areaId = localStorage.getItem("centerId")
          ? localStorage.getItem("centerId")
          : "0";
        this.$http
          .get(publicAPI.subordinateList, { params: { id: areaId } })
          .then((res) => {
            if (res.status === 200) {
              $this.areaTreeList = res.result.areaTreeListResList;
              return resolve([res.result]);
            }
          });
      }
      if (node.level == 1) {
        return resolve(this.areaTreeList);
      }

      if (node.level > 1) {
        this.loadchildnode(node, resolve);
      }
    },
    loadchildnode(node, resolve) {
      this.$http
        .get(publicAPI.subordinateList, {
          params: {
            id: node.data.id,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            return resolve(res.result.areaTreeListResList);
          }
        });
    },
    nodeClickArea(node) {
      this.areaId = node.id;
      this.areaName = node.id ? node.name : "";
      this.ruleForm.centerId = node.id;
      this.ruleForm.areaName = node.id ? node.name : "";
      this.searchParams.centerId = node.id;
      this.searchParams.areaName = node.name;
      this.searchParams.page = this.pagination.page = 1;
      this.setSearchParams();
    },
    //添加
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post(mediaApi.saveMsg, this.ruleForm).then((res) => {
            if (res.status === 200) {
              this.$message.success("发布成功！");
              this.dialogVisible = false;
              this.setSearchParams();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.system-announcement {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .system-announcement-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .system-announcement-right {
	flex: 1;
	display: flex;
	flex-direction: column;
  }

  //发布
  .form-detail {
    display: flex;
    .input-district {
      max-height: 200px;
      overflow-y: auto;
      box-sizing: border-box;
      color: #999;
      .el-tag {
        margin: 5px;
      }
    }
    .select-tree {
      max-height: 400px;
      width: 180px;
      overflow-y: auto;
      .el-tree {
        padding: 0;
      }
    }
    .el-textarea {
      width: 240px;
    }
    .el-input {
      width: 240px;
    }
  }
}
</style>
